import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
export const initDrawer = createAction(`${reduxKey}.DAMZ_INIT_DRAWER`, (filter)=>({
        filter
    }));
export const fetchDrawerNext = createCallbackActionCreator(`${reduxKey}.DAMZ_DRAWER_FETCH`);
export const setDrawerFilter = createAction(`${reduxKey}.DAMZ_DRAWER_FILTER`, (filter)=>({
        filter
    }));

//# sourceMappingURL=drawer.js.map